var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 1.334c0-.471.448-.854 1-.854h10c.552 0 1 .383 1 .854V13.28c0 .471-.448.853-1 .853h-10c-.552 0-1-.382-1-.853V1.334zm1.5 11.52V1.761h9v11.093h-9z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.75 3.894c-.414 0-.75.286-.75.64v11.307c0 .825.784 1.493 1.75 1.493H11c.414 0 .75-.286.75-.64 0-.353-.336-.64-.75-.64H1.75c-.138 0-.25-.095-.25-.213V4.534c0-.354-.336-.64-.75-.64z",
    fill: "#1C1C1C"
  })));
}
export default SvgCopyIcon;